// rc-upload 2.6.3
import upload from './src';

export default upload;
